import { render, staticRenderFns } from "./AgendaItem.vue?vue&type=template&id=029a1bf1&scoped=true&"
import script from "./AgendaItem.vue?vue&type=script&lang=js&"
export * from "./AgendaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a1bf1",
  null
  
)

export default component.exports